module.exports = __webpack_public_path__ + "img/nc_bg03.bc5c2b19.png";